import type { AppEnv } from '../../environments/app-env';

export function buildResources(env: AppEnv) {
  return {
    SITE_NAME: env.appName,
    DEFAULT_PAGE_TITLE: env.appName,
    DEFAULT_PAGE_DESC:
      'Hyr lokale eksperter eller tjen ekstra penge på Handyhand',
    PAGE_TITLES: {
      NOT_FOUND: 'Page no longer exists',
      ERROR: 'Oh oh! Something went wrong.',
      PROJECT_CONTACT: 'Contact us about a project',
      HOME: 'Homepage',
    },
    SEO_CONTENT: {
      PROJECT_TITLE: '$0, in $1',
      PROJECT_RESULTS_TITLE: '$0 projects in $1',
      PROJECT_RESULTS_DESC: 'Found $0 projects categorized under $1',
    },
  };
}

export type Resources = ReturnType<typeof buildResources>;

export const toFormat = (s: string, ...args: any) => {
  const regExp = /\$(\d+)/gi;
  return s.replace(regExp, (match, index) => {
    return args[index] ?? match;
  });
};
